export default __webpack_public_path__ + "static/media/liveScoutData.e76be0d7.png";